import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'min-w-30 whitespace-nowrap text-right font-(family-name:--primary-font) text-[0.85rem] ' +
            'text-(--input-neumorphic-text)'
    }
} satisfies ComponentTheme;
